import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Icon from "@mdi/react";
import {
    mdiHome,
    mdiClipboardTextOutline,
    mdiPrinter,
    mdiClose,
} from "@mdi/js";
import {
    getListDanhSachDonDatHang,
    updateDataSearch,
} from "../../../actions/DanhSachDonDatHang";
import { getUrl } from "utils/utils";
import "react-dropdown/style.css";
import PageNotRole from "components/ComponentImport/PageNotRole";
import { getUserLogin } from "utils/utils";
import LayoutNew from "common/LayoutNew";
import { Breadcrumb } from "common/Breadcrumb";
import { TitlePage } from "common/TitlePage";
import moment from "moment";
import { SearchBar } from "./SearchBar";
import { SearchBar1 } from "./SearchBar1";
import { TableDanhSach } from "./TableDanhSach";
import { getBranch, utilsOnChangeSelectTypeDate } from "utils/utils";
import { BtnInDanhSachRp } from "./Print/InDanhSach/BtnInDanhSachRp";
import { Index_GetConfigAllSTKey } from "actions/DanhMuc/";
import configs from "../../../constants/configs";

export const DanhSachDonDatHang = () => {
    const dispatch = useDispatch();
    const listDonHang = useSelector((state) => state.listDanhSachDonDatHang);
    const exInNhanh = useSelector((state) => state.inNhanhDanhSachDonDatHang);

    const [getLink, setGetLink] = useState();
    useEffect(() => {
        //gọi cấu hình
        dispatch(Index_GetConfigAllSTKey());
    }, []);

    // cấu hình
    const [isShowTinhThanh, setIsShowTinhThanh] = useState(null);
    const [isShowNVKD, setIsShowNVKD] = useState(null);
    const [isConfigChot, setConfigChot] = useState(null);
    const [isConfigMaPO, setIsConfigMaPO] = useState(null);
    const [isConfigThongTinLSX, setIsConfigThongTinLSX] = useState(null);

    const [isLamTronTien, setLamTronTien] = useState(null);

    const [isEditDHCheckTrangThaiKho, setIsEditDHCheckTrangThaiKho] =
        useState(null);
    const danhmuc = useSelector((state) => state.danhmuc);
    const { objConfigAll } = danhmuc;

    if (
        objConfigAll.List.length > 0 &&
        isShowTinhThanh === null &&
        isConfigChot === null &&
        isShowNVKD === null &&
        isConfigMaPO === null &&
        isEditDHCheckTrangThaiKho === null &&
        isLamTronTien == null
    ) {
        const configLamTronTIen = objConfigAll.List.find(
            (e) =>
                e.KeyID.toUpperCase() === configs.sKey.Khonglamtrontien.toUpperCase()
        );
        setLamTronTien(true);
        if (
            typeof configLamTronTIen !== "undefined" &&
            configLamTronTIen != null &&
            configLamTronTIen.Value
        ) {
            if (configLamTronTIen.Value === "1") {
                setLamTronTien(false);
            }
        }
        //
        const configShowTinhThanh = objConfigAll.List.find(
            (e) =>
                e.KeyID.toUpperCase() === configs.sKey.BanHangLocTinhThanh.toUpperCase()
        );
        console.log("configShowTinhThanh", configShowTinhThanh);

        setIsShowTinhThanh(false);
        if (
            typeof configShowTinhThanh !== "undefined" &&
            configShowTinhThanh != null &&
            configShowTinhThanh.Value
        ) {
            if (configShowTinhThanh.Value === "1") {
                setIsShowTinhThanh(true);
            }
        }
        const configNVKD = objConfigAll.List.find(
            (e) =>
                e.KeyID.toUpperCase() ===
                configs.sKey.shownhanvienkinhdoanh.toUpperCase()
        );
        setIsShowNVKD(false);
        if (
            typeof configNVKD !== "undefined" &&
            configNVKD != null &&
            configNVKD.Value
        ) {
            if (configNVKD.Value === "1") {
                setIsShowNVKD(true);
            }
        }
        //
        const stKeyChot = objConfigAll.List.find(
            (e) =>
                e.KeyID.toUpperCase() === configs.sKey.ConfigBaoGiaChot.toUpperCase()
        );
        setConfigChot(false);
        if (
            typeof stKeyChot !== "undefined" &&
            stKeyChot != null &&
            stKeyChot.Value
        ) {
            if ((isConfigChot ? "1" : "0") !== stKeyChot.Value)
                if (stKeyChot.Value == "1") setConfigChot(true);
                else setConfigChot(false);
        }
        //
        const configPO = objConfigAll.List.find(
            (e) => e.KeyID.toUpperCase() === configs.sKey.ConfigMaPO.toUpperCase()
        );
        setIsConfigMaPO(false);
        if (typeof configPO !== "undefined" && configPO != null && configPO.Value) {
            if (configPO.Value === "1") {
                setIsConfigMaPO(true);
            }
        }
        const configThongTinLSX = objConfigAll.List.find(
            (e) =>
                e.KeyID.toUpperCase() === configs.sKey.ConfigThongTinLSX.toUpperCase()
        );
        setIsConfigThongTinLSX(false);
        if (
            typeof configThongTinLSX !== "undefined" &&
            configThongTinLSX != null &&
            configThongTinLSX.Value
        ) {
            if (configThongTinLSX.Value === "1") {
                setIsConfigThongTinLSX(true);
            }
        }

        //
        const configEditDHCheckTrangThaiKho = objConfigAll.List.find(
            (e) =>
                e.KeyID.toUpperCase() ===
                configs.sKey.EditOrderUpdateStore.toUpperCase()
        );
        setIsEditDHCheckTrangThaiKho(false);
        if (
            typeof configEditDHCheckTrangThaiKho !== "undefined" &&
            configEditDHCheckTrangThaiKho != null &&
            configEditDHCheckTrangThaiKho.Value
        ) {
            if (configEditDHCheckTrangThaiKho.Value === "1") {
                setIsEditDHCheckTrangThaiKho(true);
            }
        }
        //
    }
    //
    const user = useSelector((state) => state.user);
    let { AllRoleUser } = user;
    const [roleEditDH, setRoleEditDH] = useState();
    const [roleXoaDH, setRoleXoaDH] = useState();
    const [roleDuyetYeuCau, setRoleDuyetYeuCau] = useState();
    const [roleEditDHQuaNgay, setRoleEditDHQuaNgay] = useState();
    console.log(AllRoleUser, "AllRoleUserAllRoleUserAllRoleUser");
    const [configLenhSanXuat, setConfigLenhSanXuat] = useState();
    if (typeof AllRoleUser.List != "undefined" && configLenhSanXuat == null) {
        var sRoleViewLSX = AllRoleUser.List.find(
            (e) => e.toUpperCase() === configs.sRole.LSX_TAOLENH.toUpperCase()
        );
        if (sRoleViewLSX != null) {
            setConfigLenhSanXuat(true);
        } else {
            setConfigLenhSanXuat(false);
        }
        console.log(1111111111111, configLenhSanXuat);
    }
    if (
        typeof AllRoleUser.List != "undefined" &&
        roleEditDH == null &&
        roleXoaDH == null &&
        roleDuyetYeuCau == null &&
        roleEditDHQuaNgay == null
    ) {
        var sRoleEditDH = AllRoleUser.List.find(
            (e) => e.toUpperCase() === configs.sRole.BANHANG_SUADH.toUpperCase()
        );

        if (sRoleEditDH != null) {
            setRoleEditDH(true);
        } else {
            setRoleEditDH(false);
        }
        //
        var sRoleXoaDH = AllRoleUser.List.find(
            (e) => e.toUpperCase() === configs.sRole.BANHANG_XOADH.toUpperCase()
        );

        if (sRoleXoaDH != null) {
            setRoleXoaDH(true);
        } else {
            setRoleXoaDH(false);
        }
        //
        var sRoleDuyetYeuCau = AllRoleUser.List.find(
            (e) => e.toUpperCase() === configs.sRole.HT_DUYETYEUCAU.toUpperCase()
        );

        if (sRoleDuyetYeuCau != null) {
            setRoleDuyetYeuCau(true);
        } else {
            setRoleDuyetYeuCau(false);
        }
        //
        var sRoleSuaDHQuaNgay = AllRoleUser.List.find(
            (e) =>
                e.toUpperCase() === configs.sRole.BANHANG_SUADHQUANGAY.toUpperCase()
        );
        console.log(sRoleSuaDHQuaNgay, "sRoleDuyetYeuCausRoleDuyetYeuCau");
        if (sRoleSuaDHQuaNgay != null) {
            setRoleEditDHQuaNgay(true);
        } else {
            setRoleEditDHQuaNgay(false);
        }
    }
    const [isCheckInNhanh, setIsCheckInNhanh] = useState(false);

    const [selected, setSelected] = useState({});
    const [isModalVisible, setModalVisible] = useState(false);
    const toggleModal = (status) => {
        setModalVisible(status);
    };

    const dataSearch = useSelector((state) => state.dataSearchDanhSachDonDatHang);
    const init = {
        List: [],
    };
    const [listTextSearch, setListTextSearch] = useState(init);
    /*tìm kiếm thời gian ver 2*/
    const deleteTextSearch = (index, field) => {
        const obj = { ...listTextSearch };
        obj.List.splice(index, 1);
        setListTextSearch(obj);

        if (field === "sSearch") {
            dispatch(
                updateDataSearch({
                    ...dataSearch,
                    iPageIndex: 1,
                    sSearch: "",
                })
            );
        } else if (field === "sTrangThai") {
            dispatch(
                updateDataSearch({
                    ...dataSearch,
                    iPageIndex: 1,
                    sTrangThai: "-1",
                })
            );
        } else if (field === "typeDate") {
            const thongtin = { ...dataSearch };
            thongtin.typeDate = "1";
            thongtin.iPageIndex = 1;
            utilsOnChangeSelectTypeDate(thongtin);
            setSelected({
                key: "1",
                value: "Hôm nay",
            });
            dispatch(
                updateDataSearch({
                    ...thongtin,
                    typeDate: "1",
                    iPageIndex: 1,
                })
            );
        }
    };


    return (
        <LayoutNew isProgress={listDonHang.isProgress}>
            <div className="bg-main-content">
                <div className="header-main">
                    <div className="row">
                        <div className="col-sm-10">
                            <div className="title-Search-ver2">
                                <TitlePage
                                    titlePage="Danh sách đặt hàng"
                                    IconTitle={mdiClipboardTextOutline}
                                />
                                <SearchBar1
                                    isModalVisible={isModalVisible}
                                    selected={selected}
                                    setSelected={setSelected}
                                    toggleModal={toggleModal}
                                    listTextSearch={listTextSearch}
                                    setListTextSearch={setListTextSearch}
                                />
                            </div>
                        </div>
                        {/* <div className="col-sm-7">
                            <div className="title-Search-ver2" style={{ marginTop: "0px" }}>

                            </div>
                        </div> */}
                        <div className="col-sm-2" style={{ marginTop: "10px" }}>
                            <div className="align-end ">
                                <BtnInDanhSachRp />
                            </div>
                        </div>
                    </div>
                </div>
                {/* hiển thị text search */}
                <div className="show-SearchForm-ver2" style={{ marginLeft: "18%" }}>
                    <div className="row">
                        <div className="col-lg-12">
                            {listTextSearch.List.length > 0 &&
                                listTextSearch.List.map((item, index) => {
                                    return (
                                        item.name !== "" && (
                                            <div className="show-search-ver2">
                                                {item.name === "0"
                                                    ? "Tất cả"
                                                    : item.name === "1"
                                                        ? "Hôm nay"
                                                        : item.name === "2"
                                                            ? "Hôm qua"
                                                            : item.name === "3"
                                                                ? "Tuần này"
                                                                : item.name === "4"
                                                                    ? "Tuần trước"
                                                                    : item.name === "5"
                                                                        ? "Tháng này"
                                                                        : item.name === "6"
                                                                            ? "Tháng trước"
                                                                            : item.name === "7"
                                                                                ? "Quý này"
                                                                                : item.name === "8"
                                                                                    ? "Quý trước"
                                                                                    : item.name === "9"
                                                                                        ? "Năm này"
                                                                                        : item.name === "10"
                                                                                            ? "Năm trước"
                                                                                            : item.name === "11"
                                                                                                ? "Từ ngày " +
                                                                                                moment(item.tuNgay).format("DD/MM/YYYY") +
                                                                                                " Đến ngày " +
                                                                                                moment(item.denNgay).format("DD/MM/YYYY")
                                                                                                : item.sTrangThai === "-1"
                                                                                                    ? "Trạng thái: tất cả"
                                                                                                    : item.sTrangThai === "0"
                                                                                                        ? "Trạng thái: chờ chốt"
                                                                                                        : item.sTrangThai === "1"
                                                                                                            ? "Trạng thái: đã chốt"
                                                                                                            : item.sTrangThai === "2"
                                                                                                                ? "Trạng thái: không chốt"
                                                                                                                : item.sTrangThai === "3"
                                                                                                                    ? "Trạng thái: Lên đơn 1 phần"
                                                                                                                    : item.sTrangThai === "4"
                                                                                                                        ? "Trạng thái: hoàn thành"
                                                                                                                        : item.name}
                                                <div className="iconShow-textSearch">
                                                    <a
                                                        href="#"
                                                        onClick={(e) =>
                                                            deleteTextSearch(index, item.field)
                                                        }
                                                    >
                                                        <Icon
                                                            path={mdiClose}
                                                            title="Đóng"
                                                            size={1.3}
                                                            color="#FF4D00"
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                        )
                                    );
                                })}
                        </div>
                    </div>
                </div>
                {/* End- hiển thị text search */}
                <div className="title-main-15">
                    {/* <SearchBar
                        isShowTinhThanh={isShowTinhThanh}
                        isShowNVKD={isShowNVKD}
                        isConfigChot={isConfigChot}
                        isConfigMaPO={isConfigMaPO}
                    /> */}

                    <TableDanhSach
                        configLenhSanXuat={configLenhSanXuat}
                        isConfigMaPO={isConfigMaPO}
                        isConfigThongTinLSX={isConfigThongTinLSX}
                        isLamTronTien={isLamTronTien}
                        roleEditDH={roleEditDH}
                        isEditDHCheckTrangThaiKho={isEditDHCheckTrangThaiKho}
                        isCheckInNhanh={isCheckInNhanh}
                        setIsCheckInNhanh={setIsCheckInNhanh}
                        roleXoaDH={roleXoaDH}
                        roleDuyetYeuCau={roleDuyetYeuCau}
                        roleEditDHQuaNgay={roleEditDHQuaNgay}
                    />
                    {/* <div
                    className={isModalVisible ? "bg-search-active" : ""}
                  ></div> */}
                </div>
            </div>
        </LayoutNew>
    );
};
